export function drawParticle(ctx, p, camera) {
  camera.forEachVisibleCopy(p.position.x, p.position.y, p.radius, (sx, sy) => {
    ctx.save();
    ctx.translate(sx, sy);
    ctx.fillStyle = '#fff';
    ctx.beginPath();
    ctx.arc(0, 0, p.radius, 0, 2 * Math.PI);
    ctx.closePath();
    ctx.fill();
    ctx.restore();
  })
}
